import { render, staticRenderFns } from "./backup-now.vue?vue&type=template&id=28309d2b"
import script from "./backup-now.vue?vue&type=script&lang=js"
export * from "./backup-now.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports